<template>
  <div
    class="text-center"
    :style="{
      color: color,
      backgroundColor: bgColor,
      width: '5rem',
      padding: '0.25rem',
      fontSize: 'var(--font-xs)',
      textTransform: 'capitalize',
      borderRadius: '3px',
      letterSpacing: '-3%',
    }"
  >
    {{ label }}
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  label: string;
  bgColor: string;
  color: string;
}>();
</script>
